// import React, { useEffect, useRef } from 'react';

// const CanvasEffect = () => {
//   const canvasRef = useRef(null);
//   const circles = useRef([]);

//   const drawStar = (ctx, x, y, radius, points, innerRadius) => {
//     ctx.beginPath();
//     const angle = Math.PI / points;

//     for (let i = 0; i < 2 * points; i++) {
//       const r = i % 2 === 0 ? radius : innerRadius;
//       const currX = x + r * Math.cos(i * angle);
//       const currY = y + r * Math.sin(i * angle);
//       ctx.lineTo(currX, currY);
//     }
//     ctx.closePath();
//     ctx.fillStyle = 'rgba(255, 241, 100, 1)';
//     ctx.fill();
//     ctx.strokeStyle = 'rgba(104, 98, 125, 1)';
//     ctx.lineWidth = 0.5;
//     ctx.stroke();
//   };

//   const drawCircles = (ctx, circlesArray) => {
//     circlesArray.forEach((circle) => {
//       drawStar(ctx, circle.x, circle.y, circle.radius * 2, 5, circle.radius);
//     });
//   };

//   const createObjects = (canvasWidth, canvasHeight) => {
//     const circleArray = [];
//     const numCircles = 400;
//     const circleRadius = 4;

//     for (let i = 0; i < numCircles; i++) {
//       const x = Math.random() * canvasWidth;
//       const y = Math.random() * canvasHeight;
//       circleArray.push({ x, y, originalX: x, originalY: y, radius: circleRadius });
//     }

//     return circleArray;
//   };

//   const drawGrid = (ctx, canvas) => {
//     ctx.fillStyle = 'rgba(68, 0, 138, 0.4)';
//     ctx.fillRect(0, 0, canvas.width, canvas.height);

//     const gridSize = 10;
//     ctx.strokeStyle = 'rgba(243, 200, 255, 1)';

//     for (let x = 0; x <= canvas.width; x += gridSize) {
//       ctx.beginPath();
//       ctx.moveTo(x, 0);
//       ctx.lineTo(x, canvas.height);
//       ctx.stroke();
//     }

//     for (let y = 0; y <= canvas.height; y += gridSize) {
//       ctx.beginPath();
//       ctx.moveTo(0, y);
//       ctx.lineTo(canvas.width, y);
//       ctx.stroke();
//     }
//   };

//   // 애니메이션 함수
//   const animate = (ctx, canvas) => {
//     ctx.clearRect(0, 0, canvas.width, canvas.height);

//     drawGrid(ctx, canvas);
//     drawCircles(ctx, circles.current);

//     circles.current.forEach((circle) => {
//       const dx = circle.originalX - circle.x;
//       const dy = circle.originalY - circle.y;
//       circle.x += dx * 0.02;
//       circle.y += dy * 0.02;
//     });

//     requestAnimationFrame(() => animate(ctx, canvas));
//   };

//   // 마우스 움직임 처리
//   const handleMouseMove = (e) => {
//     const mouseX = e.clientX;
//     const mouseY = e.clientY;

//     circles.current.forEach((circle) => {
//       const dx = circle.x - mouseX;
//       const dy = circle.y - mouseY;
//       const distance = Math.sqrt(dx * dx + dy * dy);

//       // 마우스에 가까운 별들이 흩어짐
//       if (distance < 100) {
//         const angle = Math.atan2(dy, dx);
//         const force = (100 - distance) / 10;
//         circle.x += Math.cos(angle) * force;
//         circle.y += Math.sin(angle) * force;
//       }
//     });
//   };

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');

//     const resizeCanvas = () => {
//       canvas.width = window.innerWidth;
//       canvas.height = window.innerHeight;

//       circles.current = createObjects(canvas.width, canvas.height);
//     };

//     resizeCanvas(); // 캔버스 초기화
//     animate(ctx, canvas); // 애니메이션 시작

//     window.addEventListener('mousemove', handleMouseMove);
//     window.addEventListener('resize', resizeCanvas);

//     return () => {
//       window.removeEventListener('mousemove', handleMouseMove);
//       window.removeEventListener('resize', resizeCanvas);
//     };
//   }, []);

//   return (
//     <canvas
//       ref={canvasRef}
//       style={{
//         position: 'fixed',
//         bottom: 0,
//         left: 0,
//         width: '100vw',
//         height: '100vh',
//         pointerEvents: 'auto',
//       }}
//     />
//   );
// };

// export default CanvasEffect;
import React, { useEffect, useRef, useCallback } from 'react';

const CanvasEffect = () => {
  const canvasRef = useRef(null);
  const circles = useRef([]);

  // 도우미 함수들 외부로 이동
  const drawStar = (ctx, x, y, radius, points, innerRadius) => {
    ctx.beginPath();
    const angle = Math.PI / points;

    for (let i = 0; i < 2 * points; i++) {
      const r = i % 2 === 0 ? radius : innerRadius;
      const currX = x + r * Math.cos(i * angle);
      const currY = y + r * Math.sin(i * angle);
      ctx.lineTo(currX, currY);
    }
    ctx.closePath();
    ctx.fillStyle = 'rgba(255, 241, 100, 1)';
    ctx.fill();
    ctx.strokeStyle = 'rgba(104, 98, 125, 1)';
    ctx.lineWidth = 0.5;
    ctx.stroke();
  };

  const drawCircles = useCallback((ctx, circlesArray) => {
    circlesArray.forEach((circle) => {
      drawStar(ctx, circle.x, circle.y, circle.radius * 2, 5, circle.radius);
    });
  }, []);

  const drawGrid = useCallback((ctx, canvas) => {
    ctx.fillStyle = 'rgba(68, 0, 138, 0.4)';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const gridSize = 10;
    ctx.strokeStyle = 'rgba(243, 200, 255, 1)';

    for (let x = 0; x <= canvas.width; x += gridSize) {
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x, canvas.height);
      ctx.stroke();
    }

    for (let y = 0; y <= canvas.height; y += gridSize) {
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.lineTo(canvas.width, y);
      ctx.stroke();
    }
  }, []);

  const createObjects = useCallback((canvasWidth, canvasHeight) => {
    const circleArray = [];
    const numCircles = 400;
    const circleRadius = 4;

    for (let i = 0; i < numCircles; i++) {
      const x = Math.random() * canvasWidth;
      const y = Math.random() * canvasHeight;
      circleArray.push({ x, y, originalX: x, originalY: y, radius: circleRadius });
    }

    return circleArray;
  }, []);

  const animateFrame = useCallback((ctx, canvas) => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    drawGrid(ctx, canvas);
    drawCircles(ctx, circles.current);

    circles.current.forEach((circle) => {
      const dx = circle.originalX - circle.x;
      const dy = circle.originalY - circle.y;
      circle.x += dx * 0.02;
      circle.y += dy * 0.02;
    });

    requestAnimationFrame(() => animateFrame(ctx, canvas));
  }, [drawGrid, drawCircles]);

  const animate = useCallback((ctx, canvas) => {
    animateFrame(ctx, canvas);
  }, [animateFrame]);

  const handleMouseMove = useCallback((e) => {
    const mouseX = e.clientX;
    const mouseY = e.clientY;

    circles.current.forEach((circle) => {
      const dx = circle.x - mouseX;
      const dy = circle.y - mouseY;
      const distance = Math.sqrt(dx * dx + dy * dy);

      // 마우스에 가까운 별들이 흩어짐
      if (distance < 100) {
        const angle = Math.atan2(dy, dx);
        const force = (100 - distance) / 10;
        circle.x += Math.cos(angle) * force;
        circle.y += Math.sin(angle) * force;
      }
    });
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      circles.current = createObjects(canvas.width, canvas.height);
    };
     
    resizeCanvas(); // 캔버스 초기화
    animate(ctx, canvas); // 애니메이션 시작

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('resize', resizeCanvas);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, [animate, createObjects, handleMouseMove]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'auto',
      }}
    />
  );
};

export default CanvasEffect;